<template>
  <div id="ModifyUserInfo">
    <div class="page-header">
      <p class="page-path">
        首页/小库托管/数据修改<span class="slashline">/</span>修改用户名和身份证号
      </p>
      <!-- <p class="page-title">修改用户名和身份证号</p> -->
    </div>
    <div class="operation-pannel" style="margin-top: 20px;">
      <el-button type="primary"  style="margin-top: 20px;" @click="showModifyDialog = true">
        修改用户名与身份证
      </el-button>
    </div>
    <div class="operation-pannel">
      <div class="search-form">
        <el-input
          v-model="filters.oldUserInfo"
          placeholder="原用户名/原身份证号"
          class="search-input"
        ></el-input>
        <el-input
          v-model="filters.newUserInfo"
          placeholder="新用户名/新身份证号"
          class="search-input"
        ></el-input>
        <el-button
          type="primary"
          @click="searchList"
          :loading="queryLoading"
          >查询</el-button
        >
        <el-button
          type="default"
          @click="resetFilters"
          >重置</el-button
        >
      </div>
      <el-table
        ref="userInfoTable"
        max-height="500"
        :data="tableData"
        border
        style="margin: 32px 0 30px"
        v-loading="queryLoading"
      >
        <el-table-column type="index" label="序号" width="60">
        </el-table-column>
        <el-table-column label="原用户名" prop="originalName"></el-table-column>
        <el-table-column label="原身份证号" prop="originalIdCard" width="180"></el-table-column>
        <el-table-column label="新用户名" prop="newlyUserName"></el-table-column>
        <el-table-column label="新身份证号" prop="newlyIdCard" width="180"></el-table-column>
        <el-table-column label="证件信息实际变更月份" prop="changeMonth"></el-table-column>
        <el-table-column label="操作时间" prop="operationTime" width="150"></el-table-column>
        <el-table-column label="操作者" prop="operationUser"></el-table-column>
      </el-table>
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :total="totalCount"
        :page-sizes="[10, 20, 30, 40, 50]"
        :page-size="pageSize"
        :current-page="currentPage"
        layout="prev, pager, next, sizes, jumper"
      >
      </el-pagination>
    </div>
    <el-dialog
      title="修改用户名与身份证号"
      :visible.sync="showModifyDialog"
      width="500px"
      @close="resetModifyForm('modifyForm')"
    >
      <el-form
        :model="modifyForm"
        ref="modifyForm"
        label-width="100px"
        :rules="rules"
      >
        <el-form-item label="原用户名：" prop="originalName">
          <el-input
            v-model="modifyForm.originalName"
            placeholder="原用户名"
          ></el-input>
        </el-form-item>
        <el-form-item label="原身份证号：" prop="originalIdCard">
          <el-input
            v-model="modifyForm.originalIdCard"
            placeholder="原身份证号"
          ></el-input>
        </el-form-item>
        <el-form-item label="新用户名：" prop="newlyName">
          <el-input
            v-model="modifyForm.newlyName"
            placeholder="新用户名"
          ></el-input>
        </el-form-item>
        <el-form-item label="新身份证号：" prop="newlyIdCard">
          <el-input
            v-model="modifyForm.newlyIdCard"
            placeholder="新身份证号"
          ></el-input>
        </el-form-item>
        <el-form-item label="变更月份：" prop="changeMonth">
          <el-date-picker
            v-model="modifyForm.changeMonth"
            type="month"
            value-format="yyyy-MM"
            placeholder="请选择月份"
          ></el-date-picker>
        </el-form-item>

    
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right;">
        <el-button
          type="primary"
          @click="submitModifyForm('modifyForm')"
          :loading="submitLoading"
          >保存</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "ModifyUserInfo",
  data: function () {
    return {
      showModifyDialog: false,
      submitLoading: false,
      queryLoading: false,
      filters: {
        oldUserInfo: "",
        newUserInfo: "",
      },
      modifyForm: {
        originalName: "",
        originalIdCard: "",
        newlyName: "",
        newlyIdCard: "",
        changeMonth: "",
      },
      rules: {
        originalName: [
          { required: true, message: "请输入原用户名", trigger: "blur" },
        ],
        originalIdCard: [
          { required: true, message: "请输入原身份证号", trigger: "blur" },
          // { pattern: /^[1-9]\d{5}(18|19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}[\dXx]$/, message: "请输入正确的身份证号", trigger: "blur" },
        ],
        newlyName: [
          { required: true, message: "请输入新用户名", trigger: "blur" },
          // { min: 2, max: 20, message: "用户名长度在2到20个字符之间", trigger: "blur" },
        ],
        
        newlyIdCard: [
          { required: true, message: "请输入新身份证号", trigger: "blur" },
          // { pattern: /^[1-9]\d{5}(18|19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}[\dXx]$/, message: "请输入正确的身份证号", trigger: "blur" },
        ],
      },
      tableData: [],
      totalCount: 0,
      pageSize: 10,
      currentPage: 1,
    };
  },
  mounted() {
    debugger
    this.getData();
  },
  methods: {
    searchList() {
      this.currentPage = 1;
      this.getData();
    },
    resetFilters() {
      this.filters = {
        oldUserInfo: "",
        newUserInfo: "",
      };
      this.searchList();
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.getData();
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getData();
    },
    async getData() {
      try {
        this.queryLoading = true;
        let listParams = {
          PageCount: this.currentPage,
          TakeCount: this.pageSize,
          OriginalUserInfo: this.filters.oldUserInfo,
          NewlyUserInfo: this.filters.newUserInfo,
        };
        let listData = await this.$api.modifyUserInfo.getUserInfoChangeList(listParams);
        // 检查业务返回码
        if (listData.code !== 200) {
          this.tableData = [];
          this.totalCount = 0;
          this.$message.error(listData.msg);
          return;
        }
        this.totalCount = listData.data.totalCount;
        this.tableData = listData.data.item;
      } catch (e) {
        console.log(e);
        this.tableData = [];
        this.totalCount = 0;
        this.$message.error(e.msg || e.message);
      } finally {
        this.queryLoading = false;
      }
    },
    submitModifyForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.saveModify();
        } else {
          return false;
        }
      });
    },
    async saveModify() {
      try {
        this.submitLoading = true;
        let params = {
          originalName: this.modifyForm.originalName,
          originalIdCard: this.modifyForm.originalIdCard,
          newlyName: this.modifyForm.newlyName,
          newlyIdCard: this.modifyForm.newlyIdCard,
          changeMonth: this.modifyForm.changeMonth,
        };
        let res = await this.$api.modifyUserInfo.modifyUserInfo(params);
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: "修改成功!",
          });
          this.showModifyDialog = false;
          this.searchList();
        } else {
          this.$message.error(res.msg || res.data.msg);
        }
      } catch (e) {
         this.$message.error(e.msg || e.data.msg);
        console.log(e);
      } finally {
        this.submitLoading = false;
      }
    },
    resetModifyForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>

<style src="@/assets/public.css"></style>
<style scoped>
#ModifyUserInfo {
  padding: 20px;
}

.operation-pannel {
  padding-top: 0;
}

.search-form {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 20px;
}

.search-input {
  width: 280px;
}
</style>